export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-[200px] h-[400px] md:w-[240px] md:h-[480px] rounded-3xl overflow-hidden border-4 border-background-200/70">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20smartphone%20mockup%20showing%20a%20trending%20news%20feed%20app%20interface%20with%20warm%20coral%20and%20amber%20accent%20colors%2C%20card%20based%20layout%20with%20rounded%20corners%2C%20chinese%20style%20minimalist%20design%2C%20soft%20shadows%2C%20white%20phone%20frame%2C%20editorial%20app%20screenshot%20aesthetic%2C%20no%20text%20visible%2C%20abstract%20content%20blocks&width=480&height=960&seq=app-mock-2026&orientation=portrait"
              alt="今日吃瓜移动端预览"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
              📱 随时随地吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              关注今日吃瓜公众号，随时随地接收最新大瓜推送。
              每日精选热门事件直达你的手机，睡前必看的吃瓜日报，精彩不容错过。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-label font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-smartphone-line"></i>
                关注公众号
              </a>
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-600 font-label text-sm hover:bg-background-200 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-download-line"></i>
                获取推送
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}